import React, { Component } from 'react';
import { TableLayout } from '../containers/Layout';
import { TableRow, TableCell, TableHead, TableBody } from '@material-ui/core';
import SingleTemplate from '../containers/SingleTemplate';


class SingleInstall extends Component {
    state = { }

    createProductList = () => {
        const { PRODUCTS, install } = this.props

        return install.products.map( installItem => {
            let prod = PRODUCTS[installItem.product_id]

            return (
                <TableRow key={installItem.id}>
                    <TableCell className="text-left">{prod.name}</TableCell>
                    <TableCell>{installItem.quantity}</TableCell>
                </TableRow>
            )
        })
    }
    
    render(){
        console.log("[PROPS] single Install",this.props);
        const { shop, client, install } = this.props;
        return(
            <SingleTemplate 
                shop={shop}
                client={client}
                sale={install}
                notif={this.props.notif}
            >
                <div>
                    <TableLayout>
                        <TableHead>
                            <TableRow>
                                <TableCell className="text-left">Produit</TableCell>
                                <TableCell>Quantité</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.createProductList()}
                            <TableRow>
                                <TableCell colSpan={2}></TableCell>
                            </TableRow>
                        </TableBody>                                
                    </TableLayout>     
                </div>
            </SingleTemplate>
        )
    }
}

export default SingleInstall;